import { errorMessages } from '../messages';
import { JQLLexer } from '@atlassianlabs/jql-parser';
/**
 * Show the appropriate error message when parsing JQL fails and a field property ID rule was expected.
 */

export var handleFieldPropertyIdRuleError = function handleFieldPropertyIdRuleError(currentToken, intl) {
  var isEOF = currentToken.type === JQLLexer.EOF;
  return isEOF ? intl.formatMessage(errorMessages.expectingFieldPropertyIdBeforeEOF) : intl.formatMessage(errorMessages.expectingFieldPropertyIdButReceived, {
    received: currentToken.text
  });
};